export const isIphonex = () => {
    // X XS, XS Max, XR
    const xSeriesConfig = [
        {
            devicePixelRatio: 3,
            width: 375,
            height: 812
        },
        {
            devicePixelRatio: 3,
            width: 414,
            height: 896
        },
        {
            //12
            devicePixelRatio: 3,
            width: 390,
            height: 844
        },
        {
            //12 pro max
            devicePixelRatio: 3,
            width: 428,
            height: 926
        },
        {
            devicePixelRatio: 2,
            width: 414,
            height: 896
        }
    ];
    // h5
    if (typeof window !== 'undefined' && window) {
        const isIOS = /iphone/gi.test(window.navigator.userAgent);
        if (!isIOS) return false;
        const {devicePixelRatio, screen} = window;
        const {width, height} = screen;
        return xSeriesConfig.some(item => item.devicePixelRatio === devicePixelRatio && item.width === width && item.height === height);
    }
    return false;
}
export const getCountryCode = ()=>{
    const language =  window.navigator.language
    const arr = language.toLowerCase().split('-')
    const firstCode = arr.slice(0,1)[0]
    const lastCode = arr.slice(-1)[0]
    if(firstCode === 'zh'){
        if(lastCode==='sg'){
            return 'SG'
        }
        return 'CN'
    }
    if(firstCode === 'gsw'){
        return 'FR'
    }
    if(lastCode === 'latn'){
        return 'ES'
    }
    if(['az-Cyrl','az-Latn','az-Latn-AZ','az-Cyrl-AZ'].includes(language)){
        return 'AZ'
    }
    if(['bs-Latn','bs-Cyrl','bs-Latn-BS','bs-Cyrl-BS'].includes(language)){
        return 'FR'
    }
    if(['ha-Latn','ha-Latn-NG'].includes(language)){
        return 'NG'
    }
    if(firstCode==='mk'){
        return 'MK'
    }
    if(['sr-Latn','sr-Cyrl'].includes(language)){
        return 'RS'
    }
    if(language === 'tg-Cyrl'){
        return 'TJ'
    }
    if(language === 'tzm-Latn'){
        return 'DZ'
    }
    if(['iu-Latn','iu-Cans'].includes(language)){
        return 'CA'
    }
    if(language === 'en-029'){
        return 'CU'
    }
    return lastCode.toUpperCase()
}
export const paypalAllowedCurrency = ['aud','brl','cad','czk','dkk','eur',
    'hkd','huf','ils','jpy','mxn','twd','nzd','nok','php',
    'pln','gbp','rub','sgd','sek','chf','thb','usd']

//获取qs
export const getURLParams = (url) => {
    if(!url){
        url = location.href
    }
    const q = {}
    url.replace(/([^?&=]+)=([^&]+)/g, (_, k, v) => {
        q[k] = v
    })
    return q
}
// 判断是否safari
export const checkSystem = () => {
    const ua = window.navigator.userAgent
    return /Safari/.test(ua) && !/Chrome/.test(ua)
}
